import { useTranslation } from 'react-i18next'
import { Button, Input, Popover, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import ProTable from '@ant-design/pro-table'
import { ModalForm } from '@ant-design/pro-form'
import { ModalFormItem } from 'components'
import './PaginationTable.scss'
import { useEffect, useState } from 'react'
import { getStroage, hasPerms } from 'utils'
import { useDispatch } from 'react-redux'
import { getHomeListAction } from 'redux/reducers'

export const PaginationTable = props => {
    const [showPopover, setShowPopover] = useState(false)
    const language = getStroage('language')
    const dispatch = useDispatch()
    const {
        type,
        dataSource,
        columns,
        modalVisible,
        setModalVisible,
        modalAddNew,
        setModalAddNew,
        setFormData,
        handleFinish,
        handleDelete,
        tableRef,
        paginatedData,
        handleChangePagination,
        pageNum,
        ModalFormItemProps,
        handleChangeFilters,
        children,
        projectListData,
        copyStatus,
        setIsCopyId,
        projectStatus,
        locationId,
    } = props
    const { t } = useTranslation()

    /* 关闭人员导入弹窗 */
    useEffect(() => {
        const handleFun = e => {
            let classname = e.target.className
            let result5 = false
            if (Object.prototype.toString.call(classname) === '[object SVGAnimatedString]') result5 = true
            if (!classname) classname = e?.target?.offsetParent?.className
            const result = classname?.match?.('copyBtn')
            const result2 = classname?.match?.('ant-popover-open')
            const result3 = classname?.match?.('ant-btn-primary')
            const result4 = classname?.match?.('ant-btn')
            const result6 = classname?.match?.('ant-input')

            if (result || result2 || result3 || result4 || result5 || result6) return
            setShowPopover(false)
        }
        window.addEventListener('click', handleFun)
        return () => window.removeEventListener('click', handleFun)
    }, [])

    return (
        <div className='PaginationTable'>
            <div className='top'>
                <span className='title'>{t(type + '.title')}</span>
                {!hasPerms('monitor:rwp', 'monitor', locationId) ? (
                    <div>
                        {copyStatus && projectStatus === '29-1' ? (
                            <Popover
                                content={
                                    <div className='copyContent'>
                                        <Input.Search
                                            onSearch={value => {
                                                const params = {
                                                    projectName: value ?? '',
                                                    pageNum: 1,
                                                    pageSize: 99999,
                                                    orderByColumn: 'update_time',
                                                    isAsc: false,
                                                }
                                                dispatch(getHomeListAction(params)) // 发送请求
                                            }}
                                        />
                                        <div className='copyList'>
                                            {projectListData ? (
                                                projectListData?.data?.map(item => (
                                                    <div
                                                        className={`copyList-item`}
                                                        key={item.id}
                                                        onClick={() => {
                                                            setIsCopyId(item.id)
                                                            setShowPopover(false)
                                                        }}
                                                    >
                                                        <span>
                                                            {language === 'zh'
                                                                ? item.projectNameAlias ?? item.projectName
                                                                : item.projectName ?? item.projectNameAlias}
                                                        </span>
                                                    </div>
                                                ))
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                }
                                trigger='click'
                                destroyTooltipOnHide={false}
                                getPopupContainer={() => document.getElementsByClassName('PaginationTable')[0]}
                                placement='bottomLeft'
                                visible={showPopover}
                            >
                                <Button type='primary' onClick={() => setShowPopover(!showPopover)} className='copyBtn'>
                                    {t('common.copyOld')}
                                </Button>
                            </Popover>
                        ) : (
                            <Tooltip title={t('LogSettings.tips11')} placement='leftBottom'>
                                <Button type='primary' className='disableBtn'>
                                    {t('LogSettings.copy')}
                                </Button>
                            </Tooltip>
                        )}
                        <Button
                            type='primary'
                            onClick={() => {
                                setModalVisible(true) // 表单显示
                                setModalAddNew(true) // 表单新建状态
                                setFormData(null) // 清空表单数据
                            }}
                        >
                            <PlusOutlined />
                            {t('common.addNew')}
                        </Button>
                    </div>
                ) : (
                    <></>
                )}
                <ModalForm
                    form={ModalFormItemProps.formInstance}
                    title={
                        modalAddNew
                            ? t(`common.${type === 'Location' ? 'addNew2' : 'addNew'}`)
                            : t(`common.${type === 'Location' ? 'edit2' : type === 'Preplot' ? 'edit3' : 'edit'}`)
                    }
                    visible={modalVisible} // 自定义控制模态框显隐
                    onVisibleChange={pre => {
                        if (!pre) {
                            setFormData(null) // 关闭表单的时候，清空表单数据
                        }
                        setModalVisible(pre) // 控制取消与关闭按钮显隐
                    }}
                    modalProps={{
                        destroyOnClose: true, // 关闭模态框销毁内部元素
                        maskClosable: false,
                        wrapClassName: type + 'Modal',
                    }} // Modal 的 props，使用方式与 antd 相同。注意：不支持 'visible'，请使用全局的 visible
                    onFinish={handleFinish} // 提交数据时触发，如果返回一个 true，会关掉模态框, false 不会关闭。如果配置了 destroyOnClose 还会重置表单。
                >
                    {children ? children : <ModalFormItem {...ModalFormItemProps} />}
                </ModalForm>
            </div>
            {/* 表格 */}
            <ProTable
                scroll={{ x: 'max-content' }}
                dataSource={dataSource} // 行数据
                columns={columns} // 列数据
                // scroll={{ x: 300 }}
                rowKey='id' // 行数据 key
                search={false} // 关闭搜索面板
                columnEmptyText={false} // 空值时的显示，不设置时显示 -， false 可以关闭此功能
                actionRef={tableRef} // 手动触发一些操作, https://procomponents.ant.design/components/table#actionref-%E6%89%8B%E5%8A%A8%E8%A7%A6%E5%8F%91
                toolBarRender={() => []} // 渲染工具栏，返回一个自定义 dom 数组
                tableAlertOptionRender={({ selectedRowKeys }) => (
                    <span className='delete' onClick={() => handleDelete(selectedRowKeys.join())}>
                        {t('common.deleteAll')}
                    </span>
                )} // 自定义批量操作工具栏右侧选项区域, false 时不显示
                options={{
                    fullScreen: false, // 全屏
                    reload: false, // 刷新
                    setting: false, // 设置列内容
                    density: false, // 密集布局
                }} // 工具栏按钮配置
                pagination={{
                    pageSize: 20, // 显示几条数据
                    total: paginatedData?.data?.total ?? 0, // 总数据
                    onChange: handleChangePagination, // 改变页数事件
                    defaultCurrent: pageNum, // 当前页（刷新、初始化）
                    simple: true, // 简单样式分页器
                }} // 分页器
                bordered={true} // 展示边框
                locale={{
                    cancelSort: '',
                    triggerAsc: '',
                    triggerDesc: '',
                }} // 删除排序功能的提示信息
                onChange={handleChangeFilters}
            />
        </div>
    )
}
